export default __webpack_public_path__ + "static/media/04.e2441c72.jpg";